module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_01-5e78e5ba340915a40c0969b9be208856.png";